import {useImperativeHandle, useRef, } from 'react'
import styled from "styled-components"
import selectOnFocus from '../../modules/autoselect'
import SearchIcon from "../icons/IconLib/SearchIcon"
import CloseIcon from "../icons/IconLib/XIcon"
const InputWrapper = styled.div`
    position: relative;
    width: ${props => props.$size === 'full' ? '100%'
                : props.$size === 'large' ? '250px'
                    : props.$size === 'medium' ? '200px'
                        : props.$size === 'small' ? '150px'
                            : 'none'
    };
    /* background: #eff3f4; */
    /* border-radius: 30px; */
`
const IconWrapper = styled.div`
    position: absolute;
    background: #eff3f4;
    /* background: red; */
    top: .3em;
    left: 0.3em;
    width: 2.7em;
    height: 2.7em;
    border-radius: 50%;
    display: ${props => !props.$visible ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    svg {
        display: ${props => props.$iconHide ? 'none' : 'block'};
        width: 0.9em; height: 0.9em;
        color: #838484;
    }
`

const Input = styled.input`
    width: 100%;
    height: 3.4em;
    border: ${props => props.$borderColor ? `2px solid ${props.$borderColor}` : '2px solid #eff3f4'} ; 

    padding: 0.5em 1em; 
    letter-spacing: 0.5px;
    outline: none;
    text-align: right;
    z-index: 0;
    background: #eff3f4;
    font-size: 1em;
    border-radius: 30px;
    -webkit-appearance: none;
    appearance: none;
    color: #8a97a5;
    &::placeholder {
        opacity: 0.5;
        
    }
    &:focus {
        animation: 2s pulse infinite;
    }
    @keyframes pulse {
        0% {
            border: 2px solid #eff3f4 ; 
        }
        50% {
            border: 2px solid #80e081; 
        }
    }
`



/**
 * @param {any} props
 */
const SearchInput = (props) => {
    const {
        input,
        setInput = (e) => console.log(e),
        value = 'חיפוש',
        fieldClietns = false,
        disabled = false,
        defaultValue = '',
        iconHide = false,
        type = 'text',
        size = 'full',
        enterFunc = (e) => console.log(e),
        ref = null,
        isEnableFocusSelect = false,
        borderColor = '',
        tabIndex,
    } = props;
    const clearInput = () => {
        setInput('')
    }
    const handleChange = (e) => {
        setInput(e.target.value)
    }
    let controlToggle = input?.length > 0 ? <span style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={clearInput}><CloseIcon /></span> : <SearchIcon />
    // Pass `value` only when the consumer manages it. Omitting `value`
    // keeps the input uncontrolled — defaultValue + onChange flow stays
    // intact for callers that debounce on change without echoing the
    // typed string back as a prop (e.g. queries/teudot-details).
    const valueProp = input !== undefined ? { value: input } : {}
    return(
        <InputWrapper $size={size}>
            {
                !disabled &&
                    <IconWrapper $iconHide={iconHide} >{controlToggle}</IconWrapper>

            }
            <Input
                style={{borderRadius: fieldClietns ? '30px 30px 0 30px' : '30px'}}
                type={type}
                placeholder={value}
                defaultValue={defaultValue}
                {...valueProp}
                onClick={type === 'number' || isEnableFocusSelect ? selectOnFocus  : undefined}
                readOnly={disabled}
                onChange={handleChange}
                min={0}
                max={9999}
                ref={ref}
                $borderColor={borderColor}
                onKeyDown={(e) => {
                    if(e.key === "Enter") {
                        enterFunc(e.target.value)
                    }

                }}
                tabIndex={tabIndex}
             />
        </InputWrapper>
    )
}
export default SearchInput;
